<template>
  <div id="con">
    <div class="centerCon">
      <img src="@/assets/logo.png" alt="" />
      <div>
        <p class="coName">大连世有电力科技有限公司</p>
        <p class="coNameEn">
          DALIAN SHIYOU ELECTRIC POWER TECHNOLOGY Co.，Ltd.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
#con {
  width: 100%;
  background-color: #ffffff;
  height: 132px;
  text-align: center;
}
.centerCon {
  overflow: hidden;
  display: inline-block;
}
.centerCon > img {
  float: left;
  height: 132px;
  text-align: left;
  transition: all 0.2s;
  opacity: 0.7;
}
.centerCon > div {
  float: left;
  /* width: calc(100% - 172px); */
  padding-left: 140px;
}
.coName {
  font-size: 30px;
  font-weight: bold;
  color: #409eff;
  height: 88px;
  line-height: 138px;
  overflow: hidden;
  font-weight: bolder;
  text-align: left;
  transition: all 0.2s;
}
.coNameEn {
  font-size: 12px;
  height: 66px;
  line-height: 44px;
  overflow: hidden;
  color: #409eff;
  text-align: left;
}

@media screen and (max-width: 671px) {
  .coName {
    font-size: 20px;
    line-height: 100px;
  }
  .coNameEn {
    line-height: 20px;
    word-break: break-all;
    position: relative;
    top: -20px;
  }
  .centerCon > img {
    float: left;
    height: 88px;
    margin-top: 18px;
  }
  .centerCon > div {
    float: left;
    width: calc(100% - 115px);
    padding: 0;
  }
}
</style>

<script>
export default {};
</script>
